import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/train.png'


const _withScopeId = n => (_pushScopeId("data-v-e0f5fd54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stationRouter" }
const _hoisted_2 = { class: "itemName" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

import Circle from './Circle.vue'
import { reactive, watch, watchEffect, ref, Ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  colNum: {
    type: Number,
    default: 4
  },
  value: {
    type: Array<string>
  }
},
  setup(__props) {

const props = __props;


const data: Ref<Array<string[]>> = ref([])   //['兰州', '阿拉山口', '莫斯科', '兰州', '阿拉山口', '莫斯科']
watch(
  () => props.value,
  (arr: Array<string> | undefined) => {
    let flag = 0
    const list: Array<string[]> = []
    arr?.map((item: string, index) => {
      if(index % props.colNum === 0) {//colNum的倍数
        list[flag] = []
        list[flag].push(item)
        flag++
      }
      else {
        list[flag-1].push(item)
      }
    })
    data.value = list
  },
  { immediate: true }
)


/**
 * 获取线路样式名
 * layer2Index   二层数组索引
 * layer1Index   一层数据索引
 */
function getClass(layer2Index: number, layer1Index: number) {
  layer2Index++;
  //console.log(props.colNum, layer2Index, props.colNum == layer2Index)
  if(props.colNum == layer2Index) {
    if(data.value.length == 1) {
      return 'itemLine'
    }
    if(layer1Index == 0)
      return 'vertical1'
    else
      return 'vertical2'
  }
  return 'itemLine'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, layer1Index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: layer1Index,
        class: "stationRouter-row"
      }, [
        (layer1Index == 0)
          ? (_openBlock(), _createBlock(Circle, { key: 0 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (item1, layer2Index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: layer2Index }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(item1), 1),
            _createElementVNode("div", {
              class: _normalizeClass(getClass(layer2Index, layer1Index))
            }, _hoisted_6, 2)
          ], 64))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})